<template>
  <div class="summary">
    <h2>Renovação</h2>
    <div class="summary__details">
      <span class="summary__details--device" />
      <div>
        <p>Aparelho</p>
        <b>{{ renewalDetails.name }}</b>
      </div>
    </div>
    <div class="summary__details">
      <span class="summary__details--coverage" />
      <div>
        <p>Cobertura</p>
        <b>{{ renewalDetails.coverage }}</b>
      </div>
    </div>
    <div class="summary__details">
      <span class="summary__details--validity" />
      <div>
        <p>Vigência</p>
        <p>
          <b>12 meses</b> (Franquia no valor de R$ {{ renewalDetails.renewalFranchise }})
        </p>
      </div>
    </div>
    <div class="summary__details">
      <span class="summary__details--period" />
      <div>
        <p>Carência</p>
        <p>
          <b>Seguro sem Carência</b> (vigência iniciada em {{ renewalDetails.renewalStartDate }})
        </p>
      </div>
    </div>
    <a
      class="summary--btn"
      target="blank"
      href='https://files.ciclic.com.br/general_conditions/Ciclic_SeguroCelular_Condicoes.pdf'>
      CONDIÇÕES GERAIS DO SEGURO
    </a>
  </div>
</template>
<script>

export default {
  name: 'RenewalSummary',
  props: {
    renewalDetails: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.summary {
  display: grid;
  justify-content: center;
  h2 {
      font: bold 24px Oscine;
      color: #444444;
      margin-bottom: 32px;
    }
  &__details {
    display: flex;
    p {
      font-family: Rubik;
      font-size: 14px;
      margin: 0;
      color: #595959;
    }

    span {
      width: 48px;
      height: 48px;
      min-width: 48px;
      display: inline-block;
      position: relative;
      margin-right: 16px;
      border-radius: 100%;
      background-color: rgba(165, 133, 255, 0.1);
    }

      div {
        :last-child {
          max-width: 288px;
          font-family: Rubik;
          font-size: 16px;
          color: #444444;
        }
      }

    &--device {
      background: url(~@/assets/svg/Smartphone.svg) no-repeat center;
    }
    &--coverage {
      background: url(~@/assets/svg/Protection.svg) no-repeat center;
    }
    &--validity {
      background: url(~@/assets/svg/Calendar.svg) no-repeat center;
    }
    &--period {
      background: url(~@/assets/svg/icons-time.svg) no-repeat center;
    }
    & + & {
      margin-top: 32px;
    }
  }

  &--btn {
    color: #6320e9 !important;
    border: solid 1px;
    border-radius: 28px;
    border-color: #6320e9 !important;
    width: 100%;
    margin-top: 24px;
    padding: 10px;
    text-align: center;
    font: bold 14px Oscine;
  }
}
</style>
